import { ISystem } from '@/modules/system/models';

export interface State {
    systems: ISystem[];
    systemSelected: ISystem;
    showRegisterForm: boolean;
}

export const state = (): State => ({
    systems: [],
    showRegisterForm: false,
    systemSelected: {
        id: 0,
        systemname: '',
        isactive: true,
    },
});
